import { cn } from "../../lib/cn";
import { buttonVariants } from "./shadcn/button";

/**
 * Carno's button vocabulary on top of shadcn/ui's buttonVariants:
 * primary = the one accent action, secondary = bordered, danger only for
 * Delete forever. Kept separate from the component so light pages (errors,
 * 404) avoid the tooltip code.
 */
export type ButtonVariant = "primary" | "secondary" | "ghost" | "outline" | "danger" | "link";
export type ButtonSize = "sm" | "md" | "lg";

const VARIANT = {
  primary: "default",
  secondary: "outline",
  ghost: "ghost",
  outline: "outline",
  danger: "destructive",
  link: "link",
} as const;

const SIZE = { sm: "sm", md: "default", lg: "lg" } as const;

const EXTRA: Record<ButtonVariant, string> = {
  primary: "shadow-xs",
  secondary: "",
  ghost: "",
  // Accent outline (sign-in providers).
  outline: "border-primary/60 hover:border-primary hover:bg-primary-soft dark:bg-transparent",
  // Solid red with white text in both themes (4.8:1).
  danger: "dark:bg-destructive dark:hover:bg-destructive/90",
  link: "h-auto px-0 has-[>svg]:px-0",
};

export function buttonStyles(opts: { variant?: ButtonVariant | null | undefined; size?: ButtonSize | null | undefined; className?: string | undefined } = {}): string {
  const variant = opts.variant ?? "secondary";
  const size = opts.size ?? "md";
  // tailwind-merge so call-site classes override the variant's (cva alone just concatenates).
  return cn(buttonVariants({ variant: VARIANT[variant], size: SIZE[size] }), EXTRA[variant], opts.className);
}
